module.exports = __webpack_public_path__ + "static/media/computer-repair.08a0acbb.jpg";